import { render } from "./master_review.vue?vue&type=template&id=793df946&scoped=true"
import script from "./master_review.vue?vue&type=script&lang=js"
export * from "./master_review.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793df946"]])

export default __exports__